interface RotatingRingAvatarProps {
  src: string;
  alt: string;
  onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  fromColor?: string;
  toColor?: string;
  children?: React.ReactNode;
}

export function RotatingRingAvatar({ 
  src, 
  alt, 
  onError, 
  fromColor = '#0a74ff', 
  toColor = '#FFD700',
  children 
}: RotatingRingAvatarProps) {
  return (
    <div className="relative w-12 h-12">
      {/* Outer ring - rotates clockwise */}
      <div 
        className="absolute inset-0 rounded-full p-[2px] animate-spin-slow"
        style={{ 
          background: `linear-gradient(to right, ${fromColor}, ${toColor})` 
        }}
      >
        <div className="w-full h-full rounded-full bg-background" />
      </div>
      
      {/* Inner ring - rotates counter-clockwise */}
      <div 
        className="absolute inset-[3px] rounded-full p-[2px] animate-spin-reverse"
        style={{ 
          background: `linear-gradient(to right, ${toColor}, ${fromColor})` 
        }}
      >
        <div className="w-full h-full rounded-full bg-background" />
      </div>
      
      {/* Image or content - stays static */}
      <div className="absolute inset-[6px] rounded-full overflow-hidden">
        {children || (
          <img 
            src={src}
            alt={alt}
            className="w-full h-full object-cover"
            onError={onError}
          />
        )}
      </div>
    </div>
  );
}
